import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rep-onworkplace-wrapper" }
const _hoisted_2 = { class: "rep-onworkplace-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "rep-onworkplace-column-name rep-onworkplace-column-item" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Имя")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Опоздали", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "rep-onworkplace-column-fine rep-onworkplace-column-item" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Время прихода")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Ушли раньше", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "rep-onworkplace-column-fine rep-onworkplace-column-item" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Время ухода")
], -1)
const _hoisted_8 = { class: "rep-onworkplace-table" }
const _hoisted_9 = { class: "rep-onworkplace-column-name rep-onworkplace-column-item" }
const _hoisted_10 = { class: "rep-onworkplace-column-is-on-place rep-onworkplace-column-item" }
const _hoisted_11 = { class: "rep-onworkplace-column-fine rep-onworkplace-column-item" }
const _hoisted_12 = { class: "rep-onworkplace-column-is-on-place rep-onworkplace-column-item" }
const _hoisted_13 = { class: "rep-onworkplace-column-fine rep-onworkplace-column-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "row-delimeter" }, null, -1)

import { onBeforeMount, reactive, watch } from 'vue'
import { Employee, FeeList, Fix, SubFilterMap } from '@/models'
import { eventBus } from '@/eventBus'
import { unitTimestampConvert, convertToSubFilterMap, ExcelData } from '@/globalFunctions'


export default /*#__PURE__*/_defineComponent({
  __name: 'WhoLate',
  setup(__props) {

const state = reactive({
  persons: [] as Employee[],
  allPersons: [] as Employee[],
  id: '',
  todayFixData: [] as Fix[],
  fee: [] as FeeList,
  startOfDay: 0,
  showFilter: false,
  filterParams: {} as SubFilterMap,
  filteredData: [] as ExcelData[]
})

const filterSteps = [{ type: 'all', text: 'Все' }, { type: 'no', text: 'Нет' }, { type: 'yes', text: 'Да' }]

const filter = reactive({
  onPlace: filterSteps[0]
})

onBeforeMount(async () => {
  await fetchData()
})

async function fetchData () {
  const now = new Date()
  state.startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()
  state.allPersons = JSON.parse(sessionStorage.getItem('persons') || '[]')
  state.persons = [...state.allPersons]
  state.todayFixData = JSON.parse(sessionStorage.getItem('today-fix') || '[]')
  state.fee = JSON.parse(sessionStorage.getItem('fee') || '[]')
}

eventBus.on('showFilter', () => {
  state.showFilter = true
})

function filterSet (obj: SubFilterMap) {
  state.filterParams = obj
}

eventBus.on('filter', (obj) => {
  const validObj = convertToSubFilterMap(obj)
  if (validObj !== null) {
    state.filterParams = validObj
  }
})

eventBus.on('reloadReport', async () => {
  await fetchData()
  state.filterParams = {}
  eventBus.emit('filter', state.filterParams)
})

function filterData () {
  if (!Object.values(state.filterParams).some(v => v)) {
    state.persons = [...state.allPersons]
  } else {
    state.persons = state.allPersons.filter(person => {
      return Object.entries(state.filterParams).every(([param, value]) => {
        if (!value) return true

        if (param === 'person') {
          return person.id === value.toString()
        }

        if (param === 'department') {
          const departments = Array.isArray(value) ? value.map(v => v.toString()) : [value.toString()]
          return person.depArr.some(dep => departments.includes(dep.toString()))
        }

        if (param === 'position') {
          const positions = Array.isArray(value) ? value.map(v => v.toString()) : [value.toString()]
          return person.posArr.some(pos => positions.includes(pos.toString()))
        }

        return true
      })
    })
  }
}

watch(() => state.filterParams, () => {
  filterData()
})

// eventBus.on('excelExport', () => {
//   prepareDataForExport()
//   exportToExcel(state.filteredData, 'fixes')
// })

function isOnPlace (id: string) {
  const index = state.todayFixData.findIndex(item => item.perId === id)
  return index > -1
}

function filterWhoOnPlace (type: string) {
  const index = filterSteps.findIndex(item => item.type === type)
  filter.onPlace = filterSteps[filterSteps.length - 1 !== index ? index + 1 : 0]
}

// function prepareDataForExport () {
//   state.filteredData = state.persons.map(person => {
//     const arriveFix = state.todayFixData.find(item => item.perId === person.id && item.type === 'arrive')
//     const leaveFix = state.todayFixData.find(item => item.perId === person.id && item.type === 'leave')
//     const personName = state.persons.find(item => item.id === person.id)?.name
//     return {
//       'Сотрудник': typeof personName === 'string' ? personName : 'Не указан',
//       'Опоздали': ,
//       'Время прихода': arriveFix ? unitTimestampConvert(arriveFix.time, 'datetime') : '-',
//       'Время ухода': leaveFix ? unitTimestampConvert(leaveFix.time, 'datetime') : '-'
//     }
//   })
// }

function showRow (id: string) {
  if (filter.onPlace.type === 'all') {
    return true
  } else {
    const onPlace = isOnPlace(id)
    if (filter.onPlace.type === 'no') {
      return !onPlace
    } else {
      return onPlace
    }
  }
}

function timeFine (id: string, type: string) {
  const item = state.todayFixData.filter(fix => fix.perId === id)
  const totalTime = item.find(fix => fix.type === type)?.time
  if (type === 'arrive') {
    const aloudLate = (state.fee.find(fee => fee.subjectId === id && fee.subjectType === 'per')?.lateTime ?? 0) * 60 * 1000
    const perStartDay = state.persons.find(per => per.id === id)?.arrivalTime ?? 0
    const timeToArrive = state.startOfDay + aloudLate + perStartDay
    if (!totalTime || totalTime === 0) {
      return Math.ceil((new Date().getTime() - timeToArrive) / 6000)
    } else {
      return Math.ceil((totalTime - timeToArrive) / 6000)
    }
  }
  if (type === 'leave') {
    const aloudLeave = state.fee.find(fee => fee.subjectId === id && fee.subjectType === 'per')?.earlyLeave ?? 0 * 60 * 1000
    const perEndDay = state.persons.find(per => per.id === id)?.leaveTime ?? 0
    const timeToLeave = state.startOfDay + perEndDay - aloudLeave
    if (!totalTime || totalTime === 0) {
      return 0
    } else {
      return Math.ceil((totalTime - timeToLeave))
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_u_filters = _resolveComponent("u-filters")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          class: "rep-onworkplace-column-is-on-place rep-onworkplace-column-item rep-onworkplace-header-block",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (filterWhoOnPlace(filter.onPlace.type)))
        }, [
          _hoisted_4,
          _createElementVNode("span", {
            class: _normalizeClass([{'rep-onworkplace-row-on-place': filter.onPlace.type === 'no'}])
          }, _toDisplayString(filter.onPlace.text), 3)
        ]),
        _hoisted_5,
        _createElementVNode("div", {
          class: "rep-onworkplace-column-is-on-place rep-onworkplace-column-item rep-onworkplace-header-block",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (filterWhoOnPlace(filter.onPlace.type)))
        }, [
          _hoisted_6,
          _createElementVNode("span", {
            class: _normalizeClass([{'rep-onworkplace-row-on-place': filter.onPlace.type === 'no'}])
          }, _toDisplayString(filter.onPlace.text), 3)
        ]),
        _hoisted_7
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.persons, (person) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: person.id
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['rep-onworkplace-table-row button-click', { 'rep-onworkplace-row-active': person.id === state.id, 'rep-onworkplace-row-on-place': !isOnPlace(person.id) }])
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", null, _toDisplayString(person.name.trim()), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(timeFine(person.id, 'arrive') ?? 0 <= 0 ? '-' : timeFine(person.id, 'arrive')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, _toDisplayString(isOnPlace(person.id)
                            ? _unref(unitTimestampConvert)(
                              state.todayFixData?.find(item => item.perId === person.id && item.type === 'arrive')?.time,
                              'datetime')
                            : '-'), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", null, _toDisplayString(timeFine(person.id, 'leave') ?? 0 < 0 ? '-' : timeFine(person.id, 'leave')), 1)
              ]),
              _createElementVNode("div", _hoisted_13, _toDisplayString(isOnPlace(person.id)
                            ? _unref(unitTimestampConvert)(
                              state.todayFixData.find(item => item.perId === person.id && item.type === 'leave')?.time,
                              'datetime')
                            : '-'), 1)
            ], 2),
            _hoisted_14
          ])), [
            [_vShow, showRow(person.id)]
          ])
        }), 128))
      ])
    ]),
    (state.showFilter)
      ? (_openBlock(), _createBlock(_component_u_filters, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (state.showFilter = false)),
          onFilterSet: filterSet,
          filters: { date: false, employs: true, department: true }
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})